/**
 * @module stores/search
 * @description 검색 파라미터 Pinia 스토어 — 각 접수 관리/이력 페이지의
 * 날짜 범위, 검색 유형, 상태, 지역, 페이지/사이즈 파라미터를 모듈별로 저장합니다.
 * HA(HA 서비스) 및 일반 접수 관리/이력 구분을 지원합니다.
 */
import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
  state: () => ({
    RepairRequestManagement: {
      fromDate: new Date(),
      toDate: new Date(),
      type: '',
      text: '',
      requestStatus: '',
      areaMainCode: '',
      areaSubCode: '',
      page: '',
      size: ''
    },
    HARepairRequestManagement: {
      fromDate: new Date(),
      toDate: new Date(),
      type: '',
      text: '',
      requestStatus: '',
      areaMainCode: '',
      areaSubCode: '',
      page: '',
      size: ''
    },
    RepairRequestHistory: {
      fromDate: new Date(),
      toDate: new Date(),
      type: '',
      text: '',
      requestStatus: '',
      areaMainCode: '',
      areaSubCode: '',
      page: '',
      size: ''
    },
    HARepairRequestHistory: {
      fromDate: new Date(),
      toDate: new Date(),
      type: '',
      text: '',
      requestStatus: '',
      areaMainCode: '',
      areaSubCode: '',
      customerName: '', // 어시스턴트 '더보기'(접수현황관리 권한 없을 때 폴백) 필터 전달
      customerPhoneNumber: '',
      page: '',
      size: ''
    }
  }),
  getters: {
    /**
     * 모듈 키로 해당 검색 조건 객체를 반환합니다.
     *
     * @param {object} state - Pinia 상태 객체
     * @returns {function(string): object} 모듈 키를 인자로 받아 검색 조건을 반환하는 함수
     */
    getSearchCriteria: (state) => (module) => state[module]
  },
  actions: {
    /**
     * 지정한 모듈의 검색 조건을 업데이트합니다.
     *
     * @param {string} module - 업데이트할 모듈 키 (예: 'RepairRequestManagement')
     * @param {object} criteria - 설정할 검색 조건 객체
     */
    setSearchCriteria(module, criteria) {
      this[module] = criteria
    }
  }
})
